module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "second_main"
  }, [_c('el-form', {
    ref: "myInfoForm",
    attrs: {
      "label-width": '30%',
      "model": _vm.myInfoFormModel,
      "rules": _vm.rules
    }
  }, [_c('h4', {
    staticClass: "second_title"
  }, [_vm._v("基本信息")]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "客户编码",
      "prop": "info1"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入客户编码",
      "disabled": true
    },
    model: {
      value: (_vm.myInfoFormModel.info1),
      callback: function($$v) {
        _vm.$set(_vm.myInfoFormModel, "info1", $$v)
      },
      expression: "myInfoFormModel.info1"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "客户类型",
      "prop": "info2"
    }
  }, [_c('el-select', {
    staticClass: "select_width",
    attrs: {
      "placeholder": "请选择客户类型",
      "disabled": ""
    },
    model: {
      value: (_vm.myInfoFormModel.info2),
      callback: function($$v) {
        _vm.$set(_vm.myInfoFormModel, "info2", $$v)
      },
      expression: "myInfoFormModel.info2"
    }
  }, _vm._l((_vm.select6), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "客户姓名",
      "prop": "info3"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入真实姓名",
      "disabled": true
    },
    model: {
      value: (_vm.myInfoFormModel.info3),
      callback: function($$v) {
        _vm.$set(_vm.myInfoFormModel, "info3", $$v)
      },
      expression: "myInfoFormModel.info3"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "注册手机号",
      "prop": "info4"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入手机号",
      "disabled": true
    },
    model: {
      value: (_vm.myInfoFormModel.info4),
      callback: function($$v) {
        _vm.$set(_vm.myInfoFormModel, "info4", $$v)
      },
      expression: "myInfoFormModel.info4"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "证件类型",
      "prop": "info5"
    }
  }, [_c('el-select', {
    staticClass: "select_width",
    attrs: {
      "placeholder": "请选择证件类型",
      "disabled": ""
    },
    model: {
      value: (_vm.myInfoFormModel.info5),
      callback: function($$v) {
        _vm.$set(_vm.myInfoFormModel, "info5", $$v)
      },
      expression: "myInfoFormModel.info5"
    }
  }, _vm._l((_vm.select7), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "证件号码",
      "prop": "info6"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入证件号码",
      "disabled": true
    },
    model: {
      value: (_vm.myInfoFormModel.info6),
      callback: function($$v) {
        _vm.$set(_vm.myInfoFormModel, "info6", $$v)
      },
      expression: "myInfoFormModel.info6"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "性别",
      "prop": "info7"
    }
  }, [_c('el-select', {
    staticClass: "select_width",
    attrs: {
      "placeholder": "请选择性别",
      "disabled": true
    },
    model: {
      value: (_vm.myInfoFormModel.info7),
      callback: function($$v) {
        _vm.$set(_vm.myInfoFormModel, "info7", $$v)
      },
      expression: "myInfoFormModel.info7"
    }
  }, _vm._l((_vm.select0), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "出生日期",
      "prop": "info8"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入出生日期",
      "disabled": true
    },
    model: {
      value: (_vm.myInfoFormModel.info8),
      callback: function($$v) {
        _vm.$set(_vm.myInfoFormModel, "info8", $$v)
      },
      expression: "myInfoFormModel.info8"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "学历",
      "prop": "info9"
    }
  }, [_c('el-select', {
    staticClass: "select_width",
    attrs: {
      "placeholder": "请选择学历"
    },
    model: {
      value: (_vm.myInfoFormModel.info9),
      callback: function($$v) {
        _vm.$set(_vm.myInfoFormModel, "info9", $$v)
      },
      expression: "myInfoFormModel.info9"
    }
  }, _vm._l((_vm.select1), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "毕业院校",
      "prop": "info10"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入毕业院校",
      "disabled": _vm.isEditable === 1
    },
    model: {
      value: (_vm.myInfoFormModel.info10),
      callback: function($$v) {
        _vm.$set(_vm.myInfoFormModel, "info10", $$v)
      },
      expression: "myInfoFormModel.info10"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    staticClass: "is-required",
    attrs: {
      "label": "所属区域",
      "prop": "info11"
    }
  }, [_c('el-cascader', {
    attrs: {
      "options": _vm.categoryList,
      "props": _vm.cascaderConfig
    },
    on: {
      "active-item-change": _vm.cascaderItemChange,
      "change": _vm.categoryChange0
    },
    model: {
      value: (_vm.info11),
      callback: function($$v) {
        _vm.info11 = $$v
      },
      expression: "info11"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "户别",
      "prop": "info12"
    }
  }, [_c('el-select', {
    ref: "repayType",
    staticClass: "select_width",
    attrs: {
      "placeholder": "请选择户别"
    },
    model: {
      value: (_vm.myInfoFormModel.info12),
      callback: function($$v) {
        _vm.$set(_vm.myInfoFormModel, "info12", $$v)
      },
      expression: "myInfoFormModel.info12"
    }
  }, _vm._l((_vm.select2), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    staticClass: "label_text is-required",
    attrs: {
      "label": "户籍地址",
      "prop": "info13"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "请输入户籍地址",
      "disabled": _vm.isEditable === 1,
      "rows": 2
    },
    model: {
      value: (_vm.myInfoFormModel.info13),
      callback: function($$v) {
        _vm.$set(_vm.myInfoFormModel, "info13", $$v)
      },
      expression: "myInfoFormModel.info13"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('h4', {
    staticClass: "second_title"
  }, [_vm._v("家庭情况")]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "婚姻状况",
      "prop": "info14"
    }
  }, [_c('el-select', {
    staticClass: "select_width",
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.myInfoFormModel.info14),
      callback: function($$v) {
        _vm.$set(_vm.myInfoFormModel, "info14", $$v)
      },
      expression: "myInfoFormModel.info14"
    }
  }, _vm._l((_vm.select3), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "家庭成员",
      "prop": "info15"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入家庭成员人数",
      "disabled": _vm.isEditable === 1
    },
    model: {
      value: (_vm.myInfoFormModel.info15),
      callback: function($$v) {
        _vm.$set(_vm.myInfoFormModel, "info15", $$v)
      },
      expression: "myInfoFormModel.info15"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("人")])], 2)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "是否有子女",
      "prop": "info16"
    }
  }, [_c('el-select', {
    staticClass: "select_width",
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.myInfoFormModel.info16),
      callback: function($$v) {
        _vm.$set(_vm.myInfoFormModel, "info16", $$v)
      },
      expression: "myInfoFormModel.info16"
    }
  }, _vm._l((_vm.select4), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "住宅状况",
      "prop": "info17"
    }
  }, [_c('el-select', {
    staticClass: "select_width",
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.myInfoFormModel.info17),
      callback: function($$v) {
        _vm.$set(_vm.myInfoFormModel, "info17", $$v)
      },
      expression: "myInfoFormModel.info17"
    }
  }, _vm._l((_vm.select5), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    staticClass: "label_text is-required",
    attrs: {
      "label": "居住住址",
      "prop": "info19"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "请输入居住住址",
      "disabled": _vm.isEditable === 1
    },
    model: {
      value: (_vm.myInfoFormModel.info19),
      callback: function($$v) {
        _vm.$set(_vm.myInfoFormModel, "info19", $$v)
      },
      expression: "myInfoFormModel.info19"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('h4', {
    staticClass: "second_title"
  }, [_vm._v("单位情况")]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "工作单位全称",
      "prop": "info20"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入工作单位全称",
      "disabled": _vm.isEditable === 1
    },
    model: {
      value: (_vm.myInfoFormModel.info20),
      callback: function($$v) {
        _vm.$set(_vm.myInfoFormModel, "info20", $$v)
      },
      expression: "myInfoFormModel.info20"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-form-item', {
    staticClass: "label_text",
    attrs: {
      "label": "单位地址",
      "prop": "info21"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "请输入单位地址",
      "disabled": _vm.isEditable === 1
    },
    model: {
      value: (_vm.myInfoFormModel.info21),
      callback: function($$v) {
        _vm.$set(_vm.myInfoFormModel, "info21", $$v)
      },
      expression: "myInfoFormModel.info21"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "任职时间",
      "prop": "info22"
    }
  }, [_c('el-date-picker', {
    ref: "datepicker",
    attrs: {
      "placeholder": "请选择日期",
      "type": "date",
      "value-format": "yyyy-MM-dd"
    },
    on: {
      "change": _vm.dateChange
    },
    model: {
      value: (_vm.myInfoFormModel.info22),
      callback: function($$v) {
        _vm.$set(_vm.myInfoFormModel, "info22", $$v)
      },
      expression: "myInfoFormModel.info22"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "任职岗位",
      "prop": "info23"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "任职岗位",
      "disabled": _vm.isEditable === 1
    },
    model: {
      value: (_vm.myInfoFormModel.info23),
      callback: function($$v) {
        _vm.$set(_vm.myInfoFormModel, "info23", $$v)
      },
      expression: "myInfoFormModel.info23"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "单位电话",
      "prop": "info24"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入单位电话",
      "disabled": _vm.isEditable === 1
    },
    model: {
      value: (_vm.myInfoFormModel.info24),
      callback: function($$v) {
        _vm.$set(_vm.myInfoFormModel, "info24", $$v)
      },
      expression: "myInfoFormModel.info24"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "单位性质",
      "prop": "info25"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入单位性质",
      "disabled": _vm.isEditable === 1
    },
    model: {
      value: (_vm.myInfoFormModel.info25),
      callback: function($$v) {
        _vm.$set(_vm.myInfoFormModel, "info25", $$v)
      },
      expression: "myInfoFormModel.info25"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "人事部联系人",
      "prop": "info26"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入人事部联系人",
      "disabled": _vm.isEditable === 1
    },
    model: {
      value: (_vm.myInfoFormModel.info26),
      callback: function($$v) {
        _vm.$set(_vm.myInfoFormModel, "info26", $$v)
      },
      expression: "myInfoFormModel.info26"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "人事部联系电话",
      "prop": "info27"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入人事部联系电话",
      "disabled": _vm.isEditable === 1
    },
    model: {
      value: (_vm.myInfoFormModel.info27),
      callback: function($$v) {
        _vm.$set(_vm.myInfoFormModel, "info27", $$v)
      },
      expression: "myInfoFormModel.info27"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    staticClass: "units",
    attrs: {
      "label": "个人年收入",
      "prop": "info28"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": "请输入个人年收入",
      "disabled": _vm.isEditable === 1
    },
    model: {
      value: (_vm.myInfoFormModel.info28),
      callback: function($$v) {
        _vm.$set(_vm.myInfoFormModel, "info28", $$v)
      },
      expression: "myInfoFormModel.info28"
    }
  }), _vm._v("元\n                           ")], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    staticClass: "units",
    attrs: {
      "label": "企业成立年限",
      "prop": "info29"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": "请输入企业成立年限",
      "disabled": _vm.isEditable === 1
    },
    model: {
      value: (_vm.myInfoFormModel.info29),
      callback: function($$v) {
        _vm.$set(_vm.myInfoFormModel, "info29", $$v)
      },
      expression: "myInfoFormModel.info29"
    }
  }), _vm._v("年\n                           ")], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    staticClass: "units",
    attrs: {
      "label": "已缴社保年限",
      "prop": "info30"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": "请输入已缴社保年限",
      "disabled": _vm.isEditable === 1
    },
    model: {
      value: (_vm.myInfoFormModel.info30),
      callback: function($$v) {
        _vm.$set(_vm.myInfoFormModel, "info30", $$v)
      },
      expression: "myInfoFormModel.info30"
    }
  }), _vm._v("年\n                           ")], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center Infosave"
  }, [_c('el-button', {
    staticClass: "personal-center-form__submit",
    staticStyle: {
      "background": "#EB662B"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.isLoading,
      "disabled": _vm.isEditable === 1
    },
    on: {
      "click": _vm.saveInfo
    }
  }, [_vm._v("\n               保存\n             ")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-356519b8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/personalCenter/PersonInfo.vue
// module id = 1008
// module chunks = 1